import { Badge } from "@/components/ui/badge";
import type { StaticSiteRow, StaticSiteSettings, StaticSiteStatus } from "@/services/staticSite/types";

const STATUS_LABEL: Record<StaticSiteStatus, string> = {
  draft: "Szkic",
  analyzed: "Po analizie",
  previewed: "Podgląd gotowy",
  deployed: "Na pages.dev",
  live: "LIVE na domenie",
  rolled_back: "Cofnięta",
  failed: "Błąd",
};

const STATUS_VARIANT: Record<StaticSiteStatus, "default" | "secondary" | "destructive" | "outline"> = {
  draft: "outline",
  analyzed: "secondary",
  previewed: "secondary",
  deployed: "default",
  live: "default",
  rolled_back: "destructive",
  failed: "destructive",
};

export function StaticSiteStatusBadge({ status }: { status: StaticSiteStatus }) {
  return <Badge variant={STATUS_VARIANT[status] || "outline"}>{STATUS_LABEL[status] || status}</Badge>;
}

export function engineLabel(site: StaticSiteRow): string {
  const s: Partial<StaticSiteSettings> = site.settings || {};
  if (s.build_backend === "astro") return s.astro_theme === "astropaper" ? "Astro · AstroPaper" : "Astro · Brand";
  return `Własny renderer · ${site.theme_id}`;
}
